var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoutLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19.057,
  height: 22,
  viewBox: "1680.493 36 19.057 22"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 10605"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 10604",
  transform: "translate(1674 31)",
  clipPath: "url(\"#a\")"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 10606",
  fill: "#fff",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.24 19.018c-.39 0-.65.26-.65.649v6.035H7.791V6.298h9.8v6.036c0 .39.259.649.648.649.39 0 .65-.26.65-.65V5.65c0-.39-.26-.649-.65-.649H7.142c-.39 0-.649.26-.649.65V26.35c0 .39.26.65.649.65h11.097c.39 0 .65-.26.65-.65v-6.684a.65.65 0 0 0-.65-.649",
  "data-name": "Path 280286"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.508 15.773c-.065-.065-.065-.13-.13-.194l-2.985-2.986c-.26-.26-.714-.194-.909.065a.682.682 0 0 0 0 .844l1.882 1.882H12.334c-.39 0-.65.26-.65.649 0 .39.26.649.65.649h11.032l-1.817 1.882a.627.627 0 0 0 0 .908c.26.26.65.26.909 0l2.985-2.985c.13-.195.13-.52.065-.714",
  "data-name": "Path 280287"
}))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0V0z",
  "data-name": "Rectangle 5519"
})))));
export default SvgLogoutLogo;